export default {
  radio: [
    { label: "АВ входит в комиссию", value: "range" },
    { label: "АВ с превышения нетто", value: "netto" },
  ],
  feeType: [
    { name: "% от суммы комиссии", id: 1 , selected: false},
    { name: "% от тарифа банка", id: 2 , selected: false},
    { name: "% годовых", id: 3 , selected: false},
    { name: "% фиксированный", id: 4 , selected: false},
    { name: "индивидуально", id: 5 , selected: false},
  ]
}
